<template>
    <el-dialog
            :visible.sync="visible"
            width="1000px"
            :title="title||'生成意见征询单'"
            @closed="dialogCloseHandler"
            custom-class="create-paper-container">

        <el-form :ref="editFormRef" :model="formData" label-width="150px" :rules="rules" @submit.native.prevent>
            <el-form-item label="问卷标题" prop="name">
                <el-input v-model="formData.name" :disabled="readonly" placeholder="请输入问卷标题"></el-input>
            </el-form-item>

            <el-form-item label="问卷主题" prop="theme">
                <div id="editor-container" />
            </el-form-item>

            <!--            <el-form-item label="问卷类型" prop="type">-->
            <!--                <el-radio-group v-model="formData.type" disabled>-->
            <!--                    <el-radio label="0">普通调查问卷</el-radio>-->
            <!--                    <el-radio label="1">满意度调查问卷</el-radio>-->
            <!--                </el-radio-group>-->
            <!--            </el-form-item>-->

<!--             <el-form-item label="人员类型" prop="audience">
                <el-radio-group v-model="formData.audience" :disabled="readonly" placeholder="请选择人员范围">
                    <el-radio label="1">全部人员</el-radio>
                    <el-radio label="2">自由选择</el-radio>
                </el-radio-group>
            </el-form-item> -->

            <el-form-item label="分配项目" prop="precinctNames">
                <el-cascader
                    :disabled="readonly"
                    ref="cascader"
                    placeholder="请选择或搜索项目"
                    v-model="formData.buildValue"
                    :options="buildTree"
                    :props="props"
                    filterable
                    show-all-levels
                    collapse-tags
                    @change="handleChangeData"
                    style="width: 400px"
                ></el-cascader>
            </el-form-item>

            <!-- <el-form-item label="屏蔽已填写人" prop="flagShield">
                <el-switch
                    :disabled="readonly"
                    v-model="formData.flagShield"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    :active-value=1
                    :inactive-value=0>
                </el-switch>
            </el-form-item>

            <el-form-item label="屏蔽的问卷填写人" prop="shieldPapers" v-show="formData.flagShield == 1">
                <div class="resource-bind-div" v-if="!readonly">
                    <div @click="showPaperInfo" style="cursor: pointer">
                        {{ (formData.shieldPapersIds||[]).length === 0 ? '点击选择问卷' : `已选择问卷[
                        ${formData.shieldPapers} ]`}}
                    </div>
                </div>
                <div class="resource-bind-div" v-else>
                    <div style="cursor: pointer">
                        {{ (formData.shieldPapersIds||[]).length === 0 ? '点击选择问卷' : `已选择问卷[
                        ${formData.shieldPapers} ]`}}
                    </div>
                </div>
                <paper-info-select ref="paperSelectRef" @submitPaperParam="submitPaperParam" :paperType="1"/>
            </el-form-item> -->

            <el-form-item label="问卷开始截止时间" prop="dataRange">
                <el-date-picker
                        :disabled="readonly"
                        is-range
                        v-model="formData.dataRange"
                        type="daterange"
                        clearable
                        format="yy/MM/dd"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        placeholder="选择问卷调查时间范围"
                        end-placeholder="结束日期"
                        align="right">
                </el-date-picker>
            </el-form-item>

            <el-form-item label="问卷数量上限" prop="total">
                <el-input-number :min="1"
                          v-model="formData.total" :disabled="readonly" placeholder="请输入问卷最大数量"></el-input-number>
            </el-form-item>

            <el-form-item label="问卷说明" prop="remarks">
                <el-input type="textarea"
                          :rows="6" v-model="formData.remarks" :disabled="readonly" placeholder="请输入问卷说明"></el-input>
            </el-form-item>


            <el-form-item label="问卷题目" v-if="readonly">
                <div class="resource-bind-div" @click="showList">
                    点击查看问卷题目
                </div>
                <paper-title-option ref="paperTitleOptionRef"/>
            </el-form-item>
        </el-form>

        <span slot="footer">
            <div class="between-warp" v-if="!readonly">
                <div style="padding-top: 4px;margin-right: 50px" v-show="!formData.id">
                <span style="color: red;">
                    是否保存问卷至题库
                </span>
                <el-radio-group v-model="formData.ifSaveToBank">
                    <el-radio label="0">否</el-radio>
                    <el-radio label="1">是</el-radio>
                </el-radio-group>
                </div>
            <div>
                 <el-button type="success" class="button-wide" @click="submitHandler" v-if="!readonly">
                     {{formData.copyInfoId?'复制':formData.id?'保存':'生成'}}
                 </el-button>
                 <el-button type="info" class="button-wide" @click="visible = false">取消</el-button>
            </div>
            </div>
            <div v-else>
                  <el-button type="info" class="button-wide" @click="visible = false">取消</el-button>
            </div>
        </span>

    </el-dialog>
</template>

<script>
import paper from '../configure/http/api/paper';


    export default JBoot({
        name: 'setConsult',
        componentName: 'setConsult',
        registryName: 'setConsult',
        components: {
            'precinct-select': require('./precinctSelect2.vue').default,
            'paper-title-option': require('./paperTitleAndOption.vue').default,
            'paper-info-select': require('./paperInfoSelect.vue').default,
        },

        data() {
            return {
                type: 0,
                moduleName: 'paper',
                submitMethod: 'saveAndInsert',
                rules: {
                    name: [{required: true, message: '请输入问卷标题'}, {min: 1, max: 225, message: '名称为1~200个字符'}],
                    // theme: [{required: true, message: '请输入问卷主题'}, {min: 1, max: 1000, message: '主题为1~1000个字符'}],
                    dataRange: [{required: true, message: '选择问卷调查时间范围'}],
                    total: [{required: true, message: '请输入问卷最大填写数量'}],
                    precincts: [{
                        required: true, trigger: 'blur', validator: (rule, value, callback) => {
                            if (!value || value.length === 0) {
                                callback(new Error('选择问卷调查分配项目'))
                            } else {
                                callback()
                            }
                        },
                    }],
                    remarks: [{min: 1, max: 225, message: '问卷内容不超过500个字符'}],
                },
                formData: {
                    flagShield: 0
                },
                buildTree: [],
                props: {
                    multiple: true,
                    label: "name",
                    value: "id",
                },
            }
        },

        computed: {
            isAdmin() {
                return this.userInfo.category && this.userInfo.category == 'admin';
            },
        },


        methods: {
            submitParam(item) {
                this.$set(this, 'formData', Object.assign({}, this.formData || {}, {
                    "paperType":1,
                    "precincts": item.submitParams,
                    "precinctNames": item.submitParams.length > 0 ? item.submitParams.map(item => item.houseName) : [],
                    "selectionRowMap": item.selectionRowMap
                }));
            },
            submitPaperParam(item) {
                this.$set(this, 'formData', Object.assign({}, this.formData || {}, {
                    "paperType":1,
                    "shieldPapersIds": item.submitParams.length > 0 ? item.submitParams.map(item => item.id) : [],
                    "shieldPapers": item.submitParams.length > 0 ? item.submitParams.map(item => item.name) : [],
                    "selectionRowMap": item.selectionRowMap
                }));
            },

/*             showProject() {
                this.$refs['precinctSelectRef'].show(Object.assign({}, {}, {
                    selectionRowMap: this.formData.selectionRowMap || {},
                    precincts: this.formData.precincts
                }));
            },
 */
            showPaperInfo() {
                this.$refs['paperSelectRef'].show(Object.assign({}, {}, {
                    selectionRowMap: this.formData.selectionRowMap || {},
                    precincts: this.formData.precincts
                }));
            },

            showList() {
                this.$refs['paperTitleOptionRef'].show(Object.assign({}, {}, {
                    infoId: this.formData.id
                }));
            },


            //是否加载表单数据
            isLoadDataInfo() {
                if (this.parentParam.id) {
                    return true;
                }
                if (!this.$route.params.routeParams) {
                    return false;
                }
                let routeParams = this.$routerParamsDecrypt(this.$route.params.routeParams || {});
                return !!this.visible && routeParams.id;
            },

            //获取加载详情时的参数
            getLoadInfoParams() {
                if (this.parentParam.id) {
                    return {
                        id: this.parentParam.id
                    };
                }
                let routeParams = this.$routerParamsDecrypt(this.$route.params.routeParams || {});
                return {id: routeParams.id};
            },


            initFormDataInfo(response) {
                if (response.id) {
                    if (response.precincts && response.precincts.length > 0) {
                        response.precincts = response.precincts.split(",");
                    }
                    var arr = [];
                    arr.push(response.startTime);
                    arr.push(response.endTime);
                    this.$set(this, 'formData', Object.assign({}, response, {
                        dataRange: arr,
                        precincts: response.precincts
                    }));
                }
                this.$set(this, 'formData', Object.assign({}, this.formData || {}, {
                    "type": this.parentParam.type ? this.parentParam.type.toString() : '0',
                    "ifSaveToBank": '0'
                }));
                this.initEditor({
                    target: document.getElementById("editor-container"),
                    content: this.formData.theme,
                }).change((value) => {
                    this.$set(this.formData, "theme", value);
                });
            },

            getEditFormDataInfo() {
                //如果检测到copyInfoId的话，则是问卷复制。
                return Object.assign({}, this.formData, {
                    column: this.constructColumn(),
                    startTime: this.dateToStrings(this.formData.dataRange[0]) + " 00:00:00",
                    endTime: this.dateToStrings(this.formData.dataRange[1]) + " 23:59:59",
                    json: JSON.stringify(this.parentParam.column),
                    precincts: this.constructPrecinct('precincts'),
                    precinctNames: this.constructPrecinct('precinctNames'),
                    shieldPapersIds: this.constructPrecinct('shieldPapersIds'),
                    shieldPapers: this.constructPrecinct('shieldPapers'),
                    copyInfoId: this.parentParam.copyInfoId == undefined ? undefined : this.parentParam.copyInfoId,
                    buildJson: this.formData.buildValue ? JSON.stringify(this.formData.buildValue): null,
                    paperType: 1,
                    audience: 1
                });
            },

            constructPrecinct(field) {
                if (!this.formData[field]) {
                    return undefined;
                }
                if (this.isString(this.formData[field]) && field.length > 0) {
                    return this.formData[field];
                }
                if (this.formData[field].length > 0) {
                    if (this.isString(this.formData[field][0])) {
                        return (this.formData[field]).join(",");
                    } else {
                        return this.formData.precincts.map(item => item.houseID).join(",")
                    }
                }
            },

            isString(object) {
                return toString.call(object) == '[object String]';
            },

            constructColumn() {
                if (this.parentParam.column && this.parentParam.column.length > 0) {
                    this.parentParam.column.forEach(item => {
                        if (!item.dicData) {
                            item.dicData = [];
                        }
                        if (item.type == 'rate' && this.formData.type == '0' && item.texts.length > 0) {
                            item.signs = [];
                            item.texts.forEach(val => {
                                item.signs.push({
                                    label: val,
                                    value: []
                                });
                            })
                        }
                    })
                }
                return this.parentParam.column;
            },

            dateToStrings(dats) {
                var date = new Date(dats);
                var year = date.getFullYear();
                var month = (date.getMonth() + 1).toString();
                var day = (date.getDate()).toString();
                if (month.length == 1) {
                    month = "0" + month;
                }
                if (day.length == 1) {
                    day = "0" + day;
                }
                var dateTime = year + "-" + month + "-" + day;
                return dateTime;
            },

            //保存题库
            saveQuestionBank(option) {
                this.$api(this.moduleName, 'saveBackTitleAndOption', option).then(response => {
                    this.submitSuccess({}, true)
                });
            },

            //提交成功之后的处理
            submitSuccess(response, flag) {
                this.$success("提交成功");
                this.dialogCloseHandler();
                this.$nextTick(function () {
                    this.$emit('submitSuccess', flag == undefined ? false : true);
                });
            },

            dialogCloseHandler() {
                if (this.visible) {
                    this.visible = false;
                } else {
                    this.$closeAllMask();
                    this.resetFormDataInfo();
                }
            },

            afterInitFormData(responseData) {
                this.showProject('xschouseInfo', 'tree');

                const { endTime_date_str, startTime_date_str, buildJson, butlerName } =
                    responseData.data || {};


                this.$set(
                    this.formData,
                    "buildValue",
                    !!buildJson ? JSON.parse(buildJson) : []
                );
                this.$set(this.formData, "butlerName", butlerName);
            },

            showProject(api, url) {
                this.dialogPvVisible = true;
                let isAdmin = false;
                if (this.userInfo.category && this.userInfo.category == 'admin') {
                    isAdmin = true
                }
                let params = {level: 5};
                if (!isAdmin) {
                   params.infoId = this.userInfo.precinctId;
                }
                this.$api(api, url, params).then((res) => {
                    this.$set(this, "buildTree", res.data);
                    this.handleChangeData();
                });
                if (this.formData.buildJson) {
                    this.$nextTick(() => {
                    this.$set(this, "buildValue", JSON.parse(this.formData.buildJson));
                    });
                } else {
                    // 清空
                    this.$nextTick(() => {
                    this.$set(this, "buildValue", []);
                    });
                }
            },
            handleChangeData(e) {
                if(this.$refs["cascader"]){
                    const arr = this.$refs["cascader"].getCheckedNodes();
                    let paperPrecinctRelationships = [];
                    let precincts = [];
                    let precinctNames = [];
                    let butlers = [];
                    let butlerName = [];
                    let buildingName = [];
                    let houseIds = [];
                    let houseNames = [];
            
                    arr.forEach((item) => {
                        if (item.level === 5) {
                            const dataShip = {};
                            dataShip.precinctId = item.pathNodes[0].data.infoId;
                            dataShip.precinctName = item.pathNodes[0].label;
                            dataShip.butlerId = item.pathNodes[1].value;
                            dataShip.butlerName = item.pathNodes[1].label;
                            dataShip.building = item.pathNodes[2].value;
                            dataShip.buildingName = item.pathNodes[2].label;
                            dataShip.houseId = item.pathNodes[4].value;
                            dataShip.houseName = item.pathNodes[4].label;

                            paperPrecinctRelationships.push(dataShip);
                
                            // 存放小区
                            if (!precincts.includes(item.pathNodes[0].data.infoId)) {
                                precincts.push(item.pathNodes[0].data.infoId);
                                precinctNames.push(item.pathNodes[0].label);
                            }
                            // 存放管家
                            if (!butlers.includes(item.pathNodes[1].value)) {
                                butlers.push(item.pathNodes[1].value);
                                butlerName.push(item.pathNodes[1].label);
                            }
                            // 存放房间号
                            if (!houseIds.includes(item.pathNodes[4].value)) {
                                houseIds.push(item.pathNodes[4].value);
                                houseNames.push(item.pathNodes[4].label);
                            }
                        }
                        if (item.level === 4 && !item.hasChildren) {
                            const dataShip = {};
                            dataShip.precinctId = item.pathNodes[0].data.infoId;
                            dataShip.precinctName = item.pathNodes[0].label;
                            dataShip.butlerId = item.pathNodes[1].value;
                            dataShip.butlerName = item.pathNodes[1].label;
                            dataShip.building = item.pathNodes[2].value;
                            dataShip.buildingName = item.pathNodes[2].label;
                            dataShip.houseId = item.pathNodes[3].value;
                            dataShip.houseName = item.pathNodes[3].label;

                            paperPrecinctRelationships.push(dataShip);
                
                            // 存放小区
                            if (!precincts.includes(item.pathNodes[0].data.infoId)) {
                                precincts.push(item.pathNodes[0].data.infoId);
                                precinctNames.push(item.pathNodes[0].label);
                            }
                            // 存放管家
                            if (!butlers.includes(item.pathNodes[1].value)) {
                                butlers.push(item.pathNodes[1].value);
                                butlerName.push(item.pathNodes[1].label);
                            }
                            // 存放房间号
                            if (!houseIds.includes(item.pathNodes[3].value)) {
                                houseIds.push(item.pathNodes[3].value);
                                houseNames.push(item.pathNodes[3].label);
                            }
                        }
                        if (item.level === 3 && !item.hasChildren) {
                            const dataShip = {};
                            dataShip.precinctId = item.pathNodes[0].data.infoId;
                            dataShip.precinctName = item.pathNodes[0].label;
                            dataShip.butlerId = item.pathNodes[1].value;
                            dataShip.butlerName = item.pathNodes[1].label;
                            dataShip.houseId = item.pathNodes[2].value;
                            dataShip.houseName = item.pathNodes[2].label;

                            paperPrecinctRelationships.push(dataShip);
                
                            // 存放小区
                            if (!precincts.includes(item.pathNodes[0].data.infoId)) {
                                precincts.push(item.pathNodes[0].data.infoId);
                                precinctNames.push(item.pathNodes[0].label);
                            }
                            // 存放管家
                            if (!butlers.includes(item.pathNodes[1].value)) {
                                butlers.push(item.pathNodes[1].value);
                                butlerName.push(item.pathNodes[1].label);
                            }
                             // 存放房间号
                             if (!houseIds.includes(item.pathNodes[2].value)) {
                                houseIds.push(item.pathNodes[2].value);
                                houseNames.push(item.pathNodes[2].label);
                            }
                        }
                        if (item.level === 2 && !item.hasChildren) {
                            const dataShip = {};
                            dataShip.precinctId = item.pathNodes[0].data.infoId;
                            dataShip.precinctName = item.pathNodes[0].label;
                            dataShip.butlerId = item.pathNodes[1].value;
                            dataShip.butlerName = item.pathNodes[1].label;
                            paperPrecinctRelationships.push(dataShip);
                
                            // 存放小区
                            if (!precincts.includes(item.pathNodes[0].data.infoId)) {
                                precincts.push(item.pathNodes[0].data.infoId);
                                precinctNames.push(item.pathNodes[0].label);
                            }
                            // 存放管家
                            if (!butlers.includes(item.value)) {
                                butlers.push(item.value);
                                butlerName.push(item.label);
                            }
                        }
                    });
                    if(precincts.length > 0){
                        this.formData.precincts = precincts.join(",");
                    }
                    if(precinctNames.length > 0){
                        this.formData.precinctNames = precinctNames.join(",");
                    }
                    if(butlers.length > 0){
                        this.formData.butlers = butlers.join(",");
                    }
                    if(butlerName.length > 0){
                        this.formData.butlerName = butlerName.join(",");
                    }
                    if(houseIds.length > 0){
                        this.formData.houseIds = houseIds.join(",");
                    }
                    if(houseNames.length > 0){
                        this.formData.houseNames = houseNames.join(",");
                    }
                    if(paperPrecinctRelationships.length > 0){
                        this.formData.paperPrecinctRelationships = paperPrecinctRelationships;
                    }
                }
            },          
        },

    }).store('userInfo').module("editor").form().build();
</script>

<style lang="scss">
    .create-paper-container {
        & > .el-dialog__body {
            padding: 10px 15px;
        }

        .between-warp {
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/setConsult.vue